import PropTypes from 'prop-types';
// @mui
import { Box, TableRow, TableCell, TableHead } from '@mui/material';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

const visuallyHidden = {
    border: 0,
    margin: -1,
    padding: 0,
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    clip: 'rect(0 0 0 0)',
};

TableListHeadComponent.propTypes = {
    order: PropTypes.oneOf(['asc', 'desc']),
    orderBy: PropTypes.string,
    rowCount: PropTypes.number,
    headLabel: PropTypes.array,
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func,
    onSelectAllClick: PropTypes.func,
};

export default function TableListHeadComponent({ headLabel }) {
    const { t } = useTranslation();
    return (
        <TableHead>
            <TableRow>
                <TableCell></TableCell>
                {headLabel.map((headCell, index) => (
                    <TableCell
                        key={index}
                        sx={{
                            whiteSpace: 'nowrap', // Đảm bảo nội dung không xuống dòng
                            overflow: 'hidden', // Ẩn nội dung bị tràn
                            textOverflow: 'ellipsis', // Thêm dấu ba chấm nếu nội dung quá dài
                        }}
                    >
                        <TableHead>{t(headCell.label)}</TableHead>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
